import * as MenuActions from '../actions/menu.actions';

export interface State {
  state: 'open' | 'hide';
  activeTab: any;
  lastClickedTab: any;
  open: boolean;
}

export const initialState: State = {
  state: 'hide',
  activeTab: null,
  lastClickedTab: null,
  open: null
};

export function reducer(
  state = initialState,
  action: MenuActions.MenuActionsUnion
): State {
  switch (action.type) {
    case MenuActions.showMenu.type: {
      return {
        ...state,
        state: 'open',
        lastClickedTab: null
      };
    }
    case MenuActions.hideMenu.type: {
      return {
        ...state,
        state: 'hide',
        lastClickedTab: null
      };
    }
    case MenuActions.toggleMenu.type: {
      return {
        ...state,
        state: state.state === 'open' ? 'hide' : 'open',
        lastClickedTab: null
      };
    }
    case MenuActions.setActiveTab.type: {
      return {
        ...state,
        activeTab: action.tab,
        lastClickedTab: null
      };
    }
    case MenuActions.lastClickedTab.type: {
      return {
        ...state,
        lastClickedTab: action.tab
      };
    }
    case MenuActions.openMobileMenu.type: {
      return {
        ...state,
        open: true
      };
    }
    case MenuActions.closeMobileMenu.type: {
      return {
        ...state,
        open: false
      };
    }
    default: {
      return state;
    }
  }
}

export const getState = (state: State) => state.state;
export const getActiveTab = (state: State) => state.activeTab;
export const isHidden = (state: State) => state.state === 'hide';
export const isOpen = (state: State) => state.open;
export const isLastClickedTabActive = (state: State) => state.lastClickedTab === state.activeTab;
